@if (event && event.published) {
    <ms-header
        [event]="event"
        [isLive]="event.live"
        [optionSets]="event.optionSets"
        [set]="setId"
        [isNewEDPScoreboard]="isNewEDPScoreboard"
        (setChange)="setChanged($event)"
        (featureChange)="featureChanged($event)" />
}

@if (isMarqueeVisible) {
    <ng-container *msComponentProxy="marqueeComponent" />
}

<div class="event-detail-wrapper" [class.disable-animation]="disableAnimation">
    @if (!event?.published || event?.isFinished()) {
        <ms-error [message]="sitecoreEventDetails.eventDetails.UnpublishedEvent" [severity]="'info'" [links]="!event?.published" />
    } @else {
        @if (isPromotionContainerVisible) {
            <ms-crm-promotion-container [promotions]="crmBannerPromotions" />
        }
        @if (+setId > -100 || isEventSitemapEnabled) {
            @if (event) {
                @if (onboardingVisible$ | async) {
                    <ms-bet-builder-onboarding [event]="event" [setId]="setId" />
                }
            }
            @switch (setId) {
                @case (setType.BetBuilder) {
                    @if (event) {
                        <ms-bet-builder-view [event]="event" [preCreated]="preCreated" />
                    }
                }
                @case (setType.MyBets) {
                    <ng-container *msComponentProxy="myBetsComponent" />
                }
                @default {
                    @if (!isEventPageModularEnabledWithWidgets) {
                        <ng-container *ngTemplateOutlet="optionGroupList; context: { $implicit: optionGroups }" />
                    } @else {
                        @for (position of eventModularVM.widgetPositions; track $index; let i = $index; let isFirst = $first; let isLast = $last) {
                            <ng-container
                                *ngTemplateOutlet="
                                    optionGroupList;
                                    context: {
                                        $implicit: optionGroups | slice: (isFirst ? 0 : eventModularVM.widgetPositions[i - 1]) : position,
                                        widgetPosition: isFirst ? 0 : eventModularVM.widgetPositions[i - 1],
                                    }
                                " />
                            @if (isMainOrAllTab) {
                                @for (widget of eventModularVM.groupedWidgets[position]; track widget) {
                                    <ms-widget-slot
                                        [widget]="[widget]"
                                        [page]="eventModularVM.widgetPage"
                                        [layoutTemplate]="eventModularVM.layoutTemplate" />
                                }
                            }
                            @if (isLast) {
                                <ng-container
                                    *ngTemplateOutlet="
                                        optionGroupList;
                                        context: { $implicit: optionGroups | slice: position, widgetPosition: position }
                                    " />
                            }
                        }
                    }
                    <ms-item
                        class="list-item-all ms-active-highlight"
                        *rxIf="setMain === setId && event!.optionSets.length > 1 && !isNewEDPScoreboard"
                        [title]="sitecoreEventDetails.eventDetails.AllBets"
                        [count]="totalOptionGroupsCount"
                        (click)="setChanged({ setId: setType.All })" />
                }
            }
        }
    }
</div>

<ng-template #optionGroupList let-optionGroupSource let-widgetPosition="widgetPosition">
    @if (event && optionGroupSource.length) {
        <ms-option-group-list
            [optionGroups]="optionGroupSource"
            [event]="event"
            [promoted]="promotedMap"
            [crmPromotedMap]="crmOptionGroupsPromotedMap"
            [crmPromoIdsMap]="crmPromoIdsMap"
            [selectedSetId]="setId"
            [thresholds]="thresholds"
            [sourceOfPick]="sourceOfPick"
            [source]="source"
            [tracking]="getTracking()"
            [defaultExpandedMarketsCount]="defaultExpandedMarkets(widgetPosition)"
            [showSixPackLogosColor]="true"
            [showSixPackLogos]="true"
            [isSGP]="isSgp"
            [optionMarketSetData]="optionMarketSetData()" />
    }
</ng-template>
